import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './components/App';
import { Colors } from './config/Constants'
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { store } from "./config/Store";

// MUI Theme
const theme = createTheme({
  palette: {
    secondary: {
      main: Colors.primaryDark
    },
    primary: {
      main: Colors.primary,
      contrastText: 'white'
    },
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();